function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#F5F5F0;}\r\n\t.st1{fill:#F2F2F2;stroke:#F2F2F2;}\r\n\t.st2{fill:#EA642D;stroke:#EA642D;}\r\n\t.st3{fill:#A05392;stroke:#A05392;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("polyline", {
  className: "st0",
  points: "-28,-22.9 -22.3,422.9 702.6,422.9 689.7,-22.9 "
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 143,
  y: 16.4,
  className: "st1",
  width: 61.9,
  height: 363.1
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M155.8,169.7h36.3c7.1,0,12.8,5.7,12.8,12.8v159.9c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8 V182.5C143,175.4,148.7,169.7,155.8,169.7z"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 217.8,
  y: 16.4,
  className: "st1",
  width: 61.9,
  height: 363.1
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M230.6,145.3h36.3c7.1,0,12.8,5.7,12.8,12.8v192.2c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8 V158.2C217.8,151.1,223.5,145.3,230.6,145.3z"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 292.5,
  y: 16.4,
  className: "st1",
  width: 61.9,
  height: 363.1
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M305.3,149h36.3c7.1,0,12.8,5.7,12.8,12.8v172.3c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8 V161.8C292.5,154.7,298.3,149,305.3,149z"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 367.3,
  y: 16.4,
  className: "st1",
  width: 61.9,
  height: 363.1
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M380.1,178h36.3c7.1,0,12.8,5.7,12.8,12.8v135.6c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8 V190.8C367.3,183.8,373,178,380.1,178z"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 442.1,
  y: 16.4,
  className: "st1",
  width: 61.9,
  height: 363.1
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M454.9,227.8h36.3c7.1,0,12.8,5.7,12.8,12.8v117.8c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8 V240.6C442.1,233.5,447.8,227.8,454.9,227.8z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M155.8,274.6h36.3c7.1,0,12.8,5.7,12.8,12.8v79.3c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8 v-79.3C143,280.4,148.7,274.6,155.8,274.6z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M230.6,274.6h36.3c7.1,0,12.8,5.7,12.8,12.8v79.3c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8 v-79.3C217.8,280.4,223.5,274.6,230.6,274.6z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M305.3,272.4h36.3c7.1,0,12.8,5.7,12.8,12.8v81.5c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8 v-81.5C292.5,278.2,298.3,272.4,305.3,272.4z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M380.1,299h36.3c7.1,0,12.8,5.7,12.8,12.8v55c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8v-55 C367.3,304.7,373,299,380.1,299z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M454.9,312h36.3c7.1,0,12.8,5.7,12.8,12.8v41.9c0,7.1-5.7,12.8-12.8,12.8h-36.3c-7.1,0-12.8-5.7-12.8-12.8 v-41.9C442.1,317.8,447.8,312,454.9,312z"
});

var SvgFamle = function SvgFamle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    x: "0px",
    y: "0px",
    viewBox: "0 0 647 400",
    style: {
      enableBackground: "new 0 0 647 400"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFamle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/famle.731a78b0.svg";
export { ForwardRef as ReactComponent };